import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'
import { isBlank } from '../../helpers/stringHelper';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { campanhaAction } from '../../store/campanha';

//COMPONENTS
import {Row, Column, IBox, Title, Content, Button, CheckBox, Icon, Return, Select} from '../inspinia';
import Pagination from "react-js-pagination";
import { relatorioAction } from '../../store/relatorio';
import Table from './tableSimples'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { EMAIL } from '../../store/tipoListaEmail';



class EnvioSimples extends React.PureComponent
{
    
    constructor(props)
    {
        super(props);    
        
        this.state = 
        {
            isGoing: true,
            loading: false,
            pageInit: 0,
            
            form: this.formInitialState(),
            list: 
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, results: undefined
            },
            comboEmpresa: 
            {
                results: undefined
            },
            comboStatus: 
            {
                results: undefined
            }, 
            comboCentroCusto: 
            {
                results: undefined
            },
            comboNomeCampanhas:
            {
                results: undefined
            }, 
            comboNomeCampanhasAutoComplete: []          
        }

        this.handlePesquisarRelatorio = this.handlePesquisarRelatorio.bind(this);
        this.handleChange             = this.handleChange.bind(this);
        this.handlePageChange         = this.handlePageChange.bind(this);
        this.handleExportRelatorio    = this.handleExportRelatorio.bind(this);
        this.handleLimparPesquisa     = this.handleLimparPesquisa.bind(this);
        this.handlePesquisarRelatorioEmail = this.handlePesquisarRelatorioEmail.bind(this);
    }


    formInitialState () 
    {
        return {
            campanha: "",
            empresa: "",
            centroCusto: "",
            nomeContato: "",
            status: "",
            email: ""
        }
    }

    handleLimparPesquisa(){
        this.state.list = [];
        this.state.form.campanha = "";
        this.state.form.empresa = "",
        this.state.form.nomeContato = "",
        this.state.form.status = "",
        this.state.form.email = "",
        this.LoadTable();
    }

    componentDidMount() {      
        this.LoadComboEmpresa();
        this.LoadComboNomeCampanhas();
        this.LoadListaCentroCusto();
        this.LoadTable();
        this.LoadComboStatus();
    }

    handleChange(e) {
        const form = this.state.form;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }

    onNomeCampanhaChange = (event, values) => {
        const form = this.state.form;
        
        this.setState({ form: { ...form, 'campanha': values.value } });
      }

    handlePesquisarRelatorio() {
       this.state.page = 1;
       this.LoadTable(this.state.page);
    }

    handlePesquisarRelatorioEmail() {
        this.state.page = 1;
        this.LoadTableEmail();
     }

    handleExportRelatorio() {
        
    }

    handlePageChange(pageNumber) {
        this.LoadTable(pageNumber);
    }

    render()
    {
        const form = this.state.form;
        const campanhas = this.state.comboNomeCampanhasAutoComplete;          

        return (            
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Envio Simples - Buscar relatório</h3>
                            </Title>
                            
                            <Content>
                                <Row className="form-row">
                                    <div className="form-group col-md-6">
                                        <label>Campanha:</label> 
                                        <Autocomplete
                                            id="campanha"
                                            options={campanhas}
                                            getOptionLabel={(option) => option.label}
                                            style={{marginTop:-8}}
                                            onChange={this.onNomeCampanhaChange}
                                            renderInput={
                                                (params) => 
                                                <TextField 
                                                    {...params} 
                                                    variant="outlined"  
                                                    margin="dense"
                                                /> 
                                            }
                                        />                                                                     
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>Empresa:</label>
                                        <Select name="empresa" selected={form.empresa} data={this.state.comboEmpresa} onChange={this.handleChange} placeholder="Empresa"  />
                                    </div>                                    
                                </Row> 

                                <Row className="form-row">
                                    <div className="form-group col-md-6">
                                        <label>Nome Contato:</label>     
                                        <input type="text" name="nomeContato" value={form.nomeContato} onChange={this.handleChange} className="form-control"/>                                                 
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>E-mail:</label>
                                        <input type="text" name="email" value={form.email} onChange={this.handleChange} className="form-control"/>  
                                    </div>                                    
                                </Row>

                                <Row className="form-row">
                                    <div className="form-group col-md-3">
                                        <label>Filtros:</label>
                                        <Select name="status" selected={form.status} data={this.state.comboStatus} onChange={this.handleChange} placeholder="Status"  />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>Centro de Custo:</label>
                                        <Select name="centroCusto" selected={form.centroCusto} data={this.state.comboCentroCusto} onChange={this.handleChange} placeholder="Centro de Custo"  />
                                    </div>  
                                    <div className="form-group col-md-1" style={{marginTop:'28px', marginLeft:"4px"}}>
                                        <Button onClick={this.handlePesquisarRelatorio}><Icon name="far fa-search"/> Pesquisar</Button>
                                    </div>
                                    <div className="form-group col-md-1" style={{marginTop:'28px', marginLeft:"40px"}}>
                                        <Button onClick={this.handlePesquisarRelatorioEmail}><Icon name="far fa-search"/>Relatório por e-mail</Button>
                                    </div>
                                    <div className="form-group col-md-1" style={{marginTop:'28px', marginLeft:"102px"}}>
                                        <Button onClick={this.handleLimparPesquisa}><Icon name="far fa-trash"/> Limpar</Button>
                                    </div>                                      
                                </Row>  

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                            <Table data={this.state.list} history={this.props.history}/>
                                    </Column>
                                </Row>                                

                            </Content>

                        </IBox>                     
                    </Column>
                </Row>

                
                
                

                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">                 
                                    
                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.pageSize}
                                        totalItemsCount={this.state.list.rowCount}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>  
                        </Row>
                    </Column>
                </Row>

            </div>
        );
    }

    LoadListaCentroCusto() {
        let self = this;        
        
        const url = `${c.API_BASE_URL}/combo-centroCusto`;
        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json' }
        };
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false, comboCentroCusto: response});
        });

    }

    LoadComboNomeCampanhas() {
        let self = this;

        const url = `${c.API_CAMPAIGN_URL}/public/campaign/campaign-name`;
        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboNomeCampanhas: response });
            self.setState({ ...self.state, loading: false, comboNomeCampanhasAutoComplete: response.results });
        });
    }

    LoadComboEmpresa() {
        let self = this;
        const data = JSON.stringify({
            'id_produto': EMAIL
        });
        const url = `${c.API_BASE_URL}/company-user`;
        const options =
        {
            method: 'POST'
            ,headers: { 'Content-Type': 'application/json' }
            ,body: data
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboEmpresa: response });
        });
    }

    LoadComboStatus()
    {
        let self = this;

        const url = `${ c.API_BASE_URL }/statusEmail`;
        const options =
        {
            method: 'GET'
            ,headers: { 'Content-Type': 'application/json' }
        };
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false, comboStatus: response});
        });
    }

    LoadTable(pageNumber)
    {
        let self = this;
        let page = pageNumber === undefined ? 0 : --pageNumber;
        let empresa = this.state.form.empresa === "Selecione..." ? "" : this.state.form.empresa;
        let status = this.state.form.status === "Selecione..." ? "" : this.state.form.status;
        let centroCusto = this.state.form.centroCusto === "Selecione..." ? "" : this.state.form.centroCusto;
        let idUsuario = self.props.auth.user.id;
        let nomeCampanha = this.state.form.campanha;  

        const url = `${ c.API_BASE_URL }/relatorio`;
        const options =
        {
            method: 'POST' 
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({
                page: page,
                idCampanha: this.state.form.campanha,
                idEmpresa:  empresa,
                nomeContato: this.state.form.nomeContato,
                status: status,
                emailContato: this.state.form.email,
                tipoRelatorio: 3,
                tipoEnvio: 'Simples',
                idCentroCusto: centroCusto
            })
        };
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false, list: response});
        });        
        
    }

    LoadTableEmail()
    {
        let self = this;
        let page = 0;

        let tipoRelatorio = this.state.form.tipoRelatorio === "" ? 0 : this.state.form.tipoRelatorio;

        let empresa = this.state.form.empresa === "Selecione..." ? "" : this.state.form.empresa;
        let status = this.state.form.status === "Selecione..." ? "" : this.state.form.status;
        let motivo = this.state.form.motivo === "Selecione..." ? "" : this.state.form.motivo;
        let centroCusto = this.state.form.centroCusto === "Selecione..." ? "" : this.state.form.centroCusto;
        let idUsuario = self.props.auth.user.id;
        let nomeCampanha = this.state.form.campanha;

        if(isBlank(nomeCampanha) && isBlank(empresa)) {
            c.TOASTER_INFO("Para realizar a essa pesquisa é necessário informar dois filtros Campanha/Empresa"); 

        } else {

            const url = `${ c.API_BASE_URL }/relatorio/email`;
            const options =
            {
                method: 'POST' 
                ,headers: { 'Content-Type': 'application/json' }
                ,body: JSON.stringify({
                    page: page,
                    idCampanha: this.state.form.campanha,
                    idEmpresa:  empresa,
                    nomeContato: this.state.form.nomeContato,
                    status: status,
                    emailContato: this.state.form.email,
                    tipoRelatorio: 3,
                    tipoEnvio: 'Simples',
                    idUsuario: idUsuario,
                    idCentroCusto: centroCusto
                })
            };

            callApi(url, options, function(response)
            { 
                if(response.status === 'OK'){
                    c.TOASTER_SUCCESS("Relatório sendo gerado, ao finalizar o processamento o relatório será enviado ao e-mail do usuário logado."); 
                }else{
                    c.TOASTER_ERROR(response.message); 
                }
            });

        }
        
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EnvioSimples));
